/* @flow */

import React from 'react';
import { Modal, Button, Message } from 'semantic-ui-react';

type Props = {
  open: boolean,
  loading?: boolean,
  title?: string,
  content: string,
  error?: string,
  onConfirm: () => void,
  onClose: () => void,
};

const DeleteModal = ({
  open,
  loading,
  title = 'Suppression',
  content,
  error,
  onConfirm,
  onClose,
}: Props) => (
  <Modal closeIcon size="small" open={open} onClose={onClose}>
    <Modal.Header>{title}</Modal.Header>
    <Modal.Content>
      {error && <Message error content={error} />}
      <p>{content}</p>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={onClose}>Non</Button>
      <Button
        disabled={!!error}
        onClick={onConfirm}
        loading={loading}
        negative
        icon="close"
        labelPosition="right"
        content="Oui"
      />
    </Modal.Actions>
  </Modal>
);

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/shared/components/DeleteModal.js